import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IAdditionalInfoSectionProps {
  disabled: boolean;
  sectionNumber: number;
}

export const AdditionalInfoSection: React.FC<IAdditionalInfoSectionProps> = ({
  disabled,
  sectionNumber,
}) => (
  <Box sx={documentGenerationFormStyles.section}>
    <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
      {sectionNumber}. Додаткова інформація
    </Typography>
    <FormInput
      name="additionalInfo"
      label="Додаткова інформація"
      multiline
      minRows={4}
      disabled={disabled}
      fullWidth
      sx={documentGenerationFormStyles.field}
    />
  </Box>
);
